// Header chip showing the active workspace's credit balance. Links to
// /settings/billing. Billing-exempt workspaces (internal team) show "∞" in
// place of a count so the internal team's dogfood sessions don't report a
// misleading zero.

import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Sparkles, Infinity as InfinityIcon } from 'lucide-react';
import { api } from '@/lib/api';

export function CreditBalanceChip() {
  const { data, isLoading } = useQuery({
    queryKey: ['me'],
    queryFn: api.me,
    refetchOnWindowFocus: true,
    staleTime: 30_000,
  });

  const exempt = data?.workspace.billing_exempt;

  return (
    <Link
      to="/settings/billing"
      data-testid="credit-chip"
      className="hidden items-center gap-1.5 rounded-full border border-rule bg-surface-sunk px-3 py-1 text-[0.75rem] font-semibold text-ink-muted transition-colors hover:border-brand-500/40 hover:bg-brand-500/10 hover:text-ink sm:inline-flex"
      aria-label={exempt ? 'Billing exempt — internal team' : `${data?.credits.balance ?? 0} credits`}
    >
      {exempt ? (
        <InfinityIcon className="h-3.5 w-3.5 text-brand-500" />
      ) : (
        <Sparkles className="h-3.5 w-3.5 text-brand-500" />
      )}
      <span className="tabular-nums">
        {isLoading ? '…' : exempt ? 'Unlimited' : `${data?.credits.balance ?? 0} cr`}
      </span>
    </Link>
  );
}
